"use client";

import { Lock } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { sendJson } from "@/components/send-json/send-json";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useRouter } from "@/i18n/use-router";

/** What a visitor sees instead of a password-protected post: its title and a box for the password; the post opens when it is right. */
export function PasswordGate({ postId, title }: { postId: string; title: string }) {
  const t = useTranslations("publicBlog.locked");
  const router = useRouter();
  const [password, setPassword] = useState("");
  const [wrong, setWrong] = useState(false);
  async function open() {
    const result = await sendJson("POST", "/api/blog/unlock", { postId, password });
    if (result.ok) router.refresh(); else setWrong(true);
  }
  return (
    <form className="mx-auto flex w-full max-w-md flex-col gap-3 rounded-2xl border p-6" onSubmit={(e) => { e.preventDefault(); void open(); }}>
      <Lock aria-hidden className="size-6 text-muted-foreground" />
      <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
      <p className="text-sm text-muted-foreground">{t("help")}</p>
      <Input type="password" value={password} autoComplete="off" aria-label={t("password")} placeholder={t("password")} aria-invalid={wrong} onChange={(e) => { setPassword(e.target.value); setWrong(false); }} />
      {wrong && <p role="alert" className="text-sm text-destructive">{t("wrong")}</p>}
      <div className="flex justify-end"><Button type="submit" disabled={!password}>{t("open")}</Button></div>
    </form>
  );
}
